const a = RegExp(/^\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/), A = RegExp(
  /^(?=.{5,254}$)(?!.*\.\.)[a-zA-Z0-9]{1}[a-zA-Z0-9!#$%&.*+/=?^'`_{|}~-]{0,64}@[a-zA-Z0-9][a-zA-Z0-9\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]{1,63}$/
), e = RegExp(
  /^[a-zA-Z ÀÈÌÒÙàèìòùÁÉÍÓÚáéíóúÂÊÎÔÛâêîôûÃÑÕãñõÄËÏÖÜŸäëïöüÿåœçÅŒÇ’`'—\-]+$/
);
export {
  A as EmailAddress,
  a as PhoneNumber,
  e as UserName
};
